import { useEffect, useRef } from "react"
import { HarvestTimeEntry, HarvestTrackingStatus } from "~/types"
import { HarvestControls } from "./HarvestControls"
import "./HarvestContextMenu.scss"
import { HarvestGroup } from "./HarvestGroup"

const groupByClientProject = (entries: HarvestTimeEntry[]) => {
  return Object.groupBy(entries, (entry) => `${entry.client}-${entry.project}`)
}

type Props = {
  trackingStatus: HarvestTrackingStatus
  isOpen: boolean
  onUpdated: () => void
}

export function HarvestContextMenu(props: Props) {
  const { trackingStatus, onUpdated, isOpen } = props
  const entries = trackingStatus.recent_entries
  const currentEntry = entries[0]
  const groupedEntries = Object.entries(groupByClientProject(entries))
  const scrollAreaRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isOpen) {
      scrollAreaRef.current?.scrollTo({ top: 0 })
    }
  }, [isOpen])

  return (
    <div className="HarvestContextMenu">
      <div className="HarvestContextMenu__title HarvestContextMenu__title--controls">
        <p>Recently tracked</p>
        <p>
          <a
            href={trackingStatus.tracker_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open timesheet
          </a>
        </p>
      </div>
      {groupedEntries.length === 0 ? (
        <div className="HarvestContextMenu__no-entries">
          <p>No recent entries.</p>
          <p>
            Open your{" "}
            <a
              href={trackingStatus.tracker_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              timesheet
            </a>{" "}
            to start tracking.
          </p>
        </div>
      ) : (
        <div className="HarvestContextMenu__scroll-area" ref={scrollAreaRef}>
          {groupedEntries.map(([key, entries]) => (
            <HarvestGroup key={key} entries={entries!} onUpdated={onUpdated} />
          ))}
        </div>
      )}
      {currentEntry && (
        <HarvestControls
          trackerLink={trackingStatus.tracker_link}
          entry={currentEntry}
          onUpdated={onUpdated}
        />
      )}
    </div>
  )
}
